import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from 'redux';

import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';

export const apiErrorLogger: Middleware = () => (next) => (action) => {
	// RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
	if (isRejectedWithValue(action)) {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		if (!!action.error) {
			ClientLogger.error(
				LoggerServices.NetworkService,
				LoggerMessages.NetworkRequestFailed,
				{
					// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
					errorCode: action?.error?.status ?? action?.payload?.status,
					// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
					errorData: action?.error.data,
					// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
					url: action?.meta?.baseQueryMeta?.request?.url,
				}
			);
		}
		// eslint-disable-next-line no-console
		console.warn(
			'We got a rejected call!' +
				`Status: ${action?.payload?.status} Endpoint: ${JSON.stringify(action?.meta.arg.endpointName)}` // eslint-disable-line
		);
	}

	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return next(action);
};
